import { useEffect } from "react";
import terminalRuntimeConfig from "../Constants/terminalRuntimeConfig";

function useZoomDisable() {
  useEffect(() => {
    if (!terminalRuntimeConfig.useZoomDisable) return;
    const preventZoom = (e) => {
      // Prevent Ctrl+Plus, Ctrl+Minus, Ctrl+0, Ctrl+Scroll
      if (
        e.ctrlKey &&
        (e.key === "+" ||
          e.key === "-" ||
          e.key === "=" ||
          e.key === "0" ||
          e.code === "Equal" ||
          e.code === "Minus" ||
          e.code === "Digit0")
      ) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }

      // Prevent F11 fullscreen
      if (e.key === "F11") {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
    };

    const preventWheelZoom = (e) => {
      // Prevent Ctrl+Scroll zoom
      if (e.ctrlKey) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
    };

    const preventTouchZoom = (e) => {
      // Prevent pinch-to-zoom on touch devices
      if (e.touches && e.touches.length > 1) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
    };

    const preventContextMenu = (e) => {
      // Prevent right-click context menu
      e.preventDefault();
      return false;
    };

    // Add event listeners
    document.addEventListener("keydown", preventZoom, { passive: false });
    document.addEventListener("wheel", preventWheelZoom, { passive: false });
    document.addEventListener("touchstart", preventTouchZoom, {
      passive: false,
    });
    document.addEventListener("touchmove", preventTouchZoom, {
      passive: false,
    });
    document.addEventListener("contextmenu", preventContextMenu, {
      passive: false,
    });

    // Set CSS to prevent zoom
    // document.body.style.zoom = "1";
    // document.body.style.transform = "scale(1)";
    // document.body.style.transformOrigin = "0 0";
    // Add meta viewport to prevent zoom on mobile
    let viewportMeta = document.querySelector('meta[name="viewport"]');
    if (!viewportMeta) {
      viewportMeta = document.createElement("meta");
      viewportMeta.name = "viewport";
      document.head.appendChild(viewportMeta);
    }
    const originalContent = viewportMeta.content;
    viewportMeta.content =
      "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no";

    return () => {
      // Cleanup event listeners
      document.removeEventListener("keydown", preventZoom);
      document.removeEventListener("wheel", preventWheelZoom);
      document.removeEventListener("touchstart", preventTouchZoom);
      document.removeEventListener("touchmove", preventTouchZoom);
      document.removeEventListener("contextmenu", preventContextMenu);
      // Reset CSS
      document.body.style.zoom = "";
      document.body.style.transform = "";
      document.body.style.transformOrigin = "";
      // Reset viewport meta
      if (viewportMeta && originalContent) {
        viewportMeta.content = originalContent;
      }
    };
  }, []);
}

export default useZoomDisable;
